import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js';

function loadGoogleAnalytics() {
    const script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-FNYKVTNTMK";
    script.async = true;
    document.head.appendChild(script);

    script.onload = function () {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-FNYKVTNTMK');
    }
}


CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "box inline",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "right",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        functionality: {},
        analytics: {}
    },
    language: {
        default: "en",
        translations: {
            en: {
                consentModal: {
                    title: "Cookie Preferences",
                    description: "",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    showPreferencesBtn: "Manage preferences",
                    footer: "<a href=\"/privacy\">Privacy Policy</a>\n<a href=\"/terms\">Terms and conditions</a>"
                },
                preferencesModal: {
                    title: "Consent Preferences Center",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Cookie Usage",
                            description: "We use necessary cookies to operate the site and optional analytics cookies only when you accept them. You can update your preferences at any time."
                        },
                        {
                            title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
                            description: "These cookies are essential for the website to function properly. They enable basic functionalities such as page navigation and access to secure areas of the site.",
                            linkedCategory: "necessary",
                            cookieTable: {
                                headers: {
                                    name: 'Name',
                                    domain: 'Service',
                                    description: 'Description',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: 'connect.sid',
                                        domain: 'Terrademia.com session',
                                        description:
                                            'Maintains your logged-in session and core account functionality.',
                                        expiration: 'Up to 3 days',
                                    },
                                    {
                                        name: 'admin.sid',
                                        domain: 'Terrademia.com admin session',
                                        description:
                                            'Maintains admin-area sessions for authorized administrators.',
                                        expiration: 'Up to 30 days',
                                    },
                                    {
                                        name: 'cf_clearance / _cf*',
                                        domain: 'Cloudflare Turnstile and bot protection',
                                        description:
                                            'Used where applicable to help verify that requests are legitimate and protect forms from abuse.',
                                        expiration: 'Session or as set by Cloudflare',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: 'Cookie Consent settings',
                                        description:
                                            'Stores your cookie consent preferences.',
                                        expiration: '6 months',
                                    }
                                ],
                            },
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Analytics cookies help us understand how visitors interact with our website. This information allows us to improve our services and tailor content to your interests.",
                            linkedCategory: "analytics",
                            cookieTable: {
                                headers: {
                                    name: 'Name',
                                    domain: 'Service',
                                    description: 'Description',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: 'Google Analytics',
                                        description:
                                            'Cookie set by <a href="https://policies.google.com/privacy?hl=en-US">Google Analytics</a>.',
                                        expiration: 'Set by Google Analytics',
                                    },
                                    {
                                        name: '_gid',
                                        domain: 'Google Analytics',
                                        description:
                                            'Cookie set by <a href="https://policies.google.com/privacy?hl=en-US">Google Analytics</a>',
                                        expiration: 'Set by Google Analytics',
                                    }
                                ],
                            },
                        },
                        {
                            title: "More information",
                            description: "For any query in relation to our policy on cookies and your choices, please <a class=\"cc__link\" href=\"/contact\">contact us</a>."
                        }
                    ]
                }
            }
        }
    },
    onConsent: function () {
        if (CookieConsent.acceptedCategory('analytics')) {
            console.log("GA enabled");
            loadGoogleAnalytics();
        }
    },
    onChange: function ({ changedCategories }) {
        if (changedCategories.includes('analytics')) {

            if (CookieConsent.acceptedCategory('analytics')) {
                console.log("GA enabled");
                loadGoogleAnalytics();
            } else {
                console.log("GA disabled");
                window['ga-disable-G-FNYKVTNTMK'] = true;
            }
        }
    }

    });